import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
	Refund,
	RefundCorrectionReason,
	RefundHistory,
	RefundReason,
	RepaymentOwner,
	ReturnedReason
} from '@edassist/api';
import { RefundMethod } from '../../models/payment/refund-method.interface';
import { RefundDistribution } from '../../models/payment/refund-distribution.interface';

@Injectable({ providedIn: 'root' })
export class RefundService {

	constructor(private readonly http: HttpClient) {
	}

	getRepaymentOwners(): Observable<Array<RepaymentOwner>> {
		return this.http.get<Array<RepaymentOwner>>(
			'refunds/repayment-owners'
		);
	}

	getRefundMethods(): Observable<Array<RefundMethod>> {
		return this.http.get<Array<RefundMethod>>(
			'refunds/refund-methods'
		);
	}

	getRefundReasons(): Observable<Array<RefundReason>> {
		return this.http.get<Array<RefundReason>>(
			'refunds/refund-reasons'
		);
	}

	getReturnedReasons(): Observable<Array<ReturnedReason>> {
		return this.http.get<Array<ReturnedReason>>(
			'refunds/returned-reasons'
		);
	}

	getRefundCorrectionReasons(): Observable<Array<RefundCorrectionReason>> {
		return this.http.get<Array<RefundCorrectionReason>>(
			'refunds/refund-correction-reasons'
		);
	}

	patchRefund(applicationId: number, refundId: number, patchObjs: Array<any>, correctionReasonId: number): Observable<Refund> {
		let params = new HttpParams();
		params = params.append('correctionReasonId', correctionReasonId);

		return this.http.patch<Refund>(
			`applications/${applicationId}/refunds/${refundId}`,
			patchObjs,
			{
				params: params
			}
		)
	}

	updateRefundDistribution(applicationId: number, refundId: number, refundDistributionId: number, appliedAmount: number):
		Observable<RefundDistribution> {
		let params = new HttpParams();
		params = params.append('appliedAmount', appliedAmount);

		return this.http.put<RefundDistribution>(
			`applications/${applicationId}/refunds/${refundId}/refund-distributions/${refundDistributionId}`,
			undefined,
			{
				params: params
			}
		)
	}

	addRefund(applicationId: number, refund: Refund): Observable<Refund> {
		return this.http.post<Refund>(
			`applications/${applicationId}/refunds`,
			refund
		);
	}

	addRefundDistribution(applicationId: number, refundId: number, refundDistribution: RefundDistribution): Observable<void> {
		return this.http.post<void>(
			`applications/${applicationId}/refunds/${refundId}/refund-distribution`,
			refundDistribution
		);
	}

	getRefundHistory(refundId: number): Observable<Array<RefundHistory>> {
		return this.http.get<Array<RefundHistory>>(`applications/refunds/${refundId}/history`);
	}
}